import { TradeFormDetails } from 'src/components/TradeConfirmationModal/types';
import useModal from 'src/components/Modals/hooks/useModal';
import TextButton from 'src/components/primitives/TextButton/TextButton';
import { ChevronRight } from '@velocity-exchange/icons';

interface Props {
	tradeFormDetails: TradeFormDetails;
}

export const OrderRetryButton = ({ tradeFormDetails }: Props) => {
	const { show } = useModal();

	const handleClick = () => {
		show({ type: 'trade_confirmation', props: { tradeFormDetails } });
	};

	return (
		<TextButton
			size="sm"
			variant="primary"
			rightIcon={ChevronRight}
			onClick={handleClick}
		>
			Try again
		</TextButton>
	);
};
